import styled from '@emotion/styled';

import DeleteIcon from '@mui/icons-material/Delete';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import EditIcon from '@mui/icons-material/EditRounded';
import IconButton from '@mui/material/IconButton';

import SimpleChip from '../SimpleChip';

import BlockFlex from '../BlockFlex';

import { TextField } from '@mui/material';

import useIsMobile from '../../../hooks/useIsMobile';


const WigItem = styled.div`
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  gap: 1rem;
  padding: .8rem 1rem;
  border: 1px solid ${props => props.theme.colors.border};
  border-left: 3px solid ${props => props.theme.colors.secondary};
  background-color: ${props => props.theme.colors.headerBg};
  border-radius: 3px;
`;

const WigItemInfo = styled.div`
  display: flex;
  justify-content: space-between;

  @media ${props => props.theme.breaks.down("md")} {
    flex-direction: column;
  }
`;

const WigItemTitleContainer = styled.div`
  min-width: 25rem;
`;

const WigItemTitle = styled.div`
 text-transform: uppercase;
 background-color: ${props => props.theme.colors.primaryFaint};
 color: ${props => props.theme.colors.primary};
 font-weight: 500;
 height: fit-content;
 padding: .2rem 1rem;
 border-radius: 3px;
 width: fit-content;
`;

const WigItemActions = styled.div`
  display: flex;
  gap: 1rem;

  @media ${props => props.theme.breaks.down("md")} {
    justify-content: flex-end;
  }
  
`;  

const WigItemDetails = styled.div`
  /* display: flex;
  gap: 2rem; */
  flex-grow: 1;
  padding: 0 4rem;
`;

const Quantities = styled.div`
  display: flex;
  gap: .6rem;
  align-items: center;
`;

const Fulfilled = styled.div`
  font-size: 1.7rem;

  .fulfilled_qty {
    color: ${props => props.theme.colors.primary};
    font-weight: 600;
  }
`;

const InventoryItem = ({item, fields = [{title: 'Brand', field: 'brand_name'}, {title: "Line", field: "line"}, {title: 'Color', field: "color"}, {title: 'Length', field: "length"}, {title: 'Type', field: "material"}, {title: "Cap", field: "cap_size"}], editItem, removeItem, arr, displayOnly = false }) => {

  const isMobile = useIsMobile();

  const { sku, new_fulfilled_qty, fulfilled_qty = 0, qty = '' } = item

  let displayFields = fields.map(({title, field}) => ({title, info: item[field]})).filter(({info}) => info);

  return (
    <WigItem>
      <WigItemInfo>
        <WigItemTitleContainer>
          <SimpleChip label={sku} uc palette="primary" size={isMobile ? "small" : "medium"}></SimpleChip>
        </WigItemTitleContainer>
        {/* <WigItemDetails>
          <BlockFlex display={displayFields} />
        </WigItemDetails> */}
        <WigItemActions>
          <Quantities> 
            <Fulfilled><span className='fulfilled_qty'>{new_fulfilled_qty || fulfilled_qty}</span> /</Fulfilled>
         {!displayOnly ? <TextField placeholder='Quantity' size='small' type='number' value={qty} onChange={(e) => editItem(e, arr, sku, 'qty')} /> : (qty || 0)}</Quantities>
         
          {/* <IconButton color="secondary" size='small'>
            <EditIcon />
          </IconButton> */}
          <IconButton color="error" size='small' onClick={() => removeItem(item.sku, arr)}>
            <DeleteIcon />
          </IconButton>
        </WigItemActions>
      </WigItemInfo>
    </WigItem>
  )
}

export default InventoryItem;